// extracted by mini-css-extract-plugin
export default {"input":"IOLyF","rangeWrapper":"emuTf","inputWithInfoWrapper":"k9NRu","error":"dHlJF","rangeTitle":"YyZUq","switcher":"dP4w7","switcherActive":"jTFsW","errorIcon":"xUiaN"};